import { render, staticRenderFns } from "./bankinfo-list.vue?vue&type=template&id=13b7e3c3&"
import script from "./bankinfo-list.vue?vue&type=script&lang=js&"
export * from "./bankinfo-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "bankinfo-list.vue"
export default component.exports